export default "__VITE_ASSET__B_1fDpFr__"